/**
 * kult-sampler-sum.js — Probierset im Summen-Modus (snippets/kult-pdp-sampler-buybox.liquid, [data-sampler-sum]).
 * Der Preis ist die Summe der gewählten Kaffees. In den Warenkorb kommen die echten Kaffee-Varianten
 * (Slot-Größe × gewählte Zubereitung) mit der Eigenschaft „Set: Probierset“, nicht das Probierset-Produkt.
 * Daten: script[data-sampler-data] { label, coffees: { handle: { title, v: [{id, o[], p, a, u, r}] } } }.
 * Fängt das Absenden in der Capture-Phase am Wrapper ab, damit kult-pdp.js das Probierset-Produkt nicht hinzufügt.
 * Sendet nach dem Hinzufügen 'kult:cart:add' { cart, title } wie kult-pdp.js (öffnet den Drawer).
 * Grundpreis der Summe (PAngV, 03.10.2026): [data-sampler-unit] „Summe der 3 Kaffees · 750 g (39,60 €/kg)“,
 * Gramm aus den Slot-Größen (data-size „250 g“ / „1 kg“), Grundpreis = Summe je Set ÷ Gramm × 1000.
 * Firmenkunden-Ansicht (04.10.2026): Trägt der Wrapper data-b2b-vat (MwSt.-Satz in %), rechnet das Skript jeden Variantenpreis
 * und Grundpreis auf Netto (Brutto × 100 / (100 + MwSt.), auf Cent gerundet wie snippets/kult-b2b-net) und hängt „netto“ an
 * den Grundpreis der Summe. Ohne das Attribut bleibt alles wie bisher (Bruttopreise).
 */
(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init(root) {
    if (!root || root.hasAttribute('data-sampler-ready')) return;
    var dataEl = root.querySelector('script[data-sampler-data]');
    var form = root.querySelector('form');
    if (!dataEl || !form) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.setAttribute('data-sampler-ready', '');

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-sampler-select]'));
    /* Vorbelegung aus dem Kaffeefinder: ?sorten=handle1,handle2,handle3 füllt die Kaffee-Plätze der Reihe nach */
    try {
      var want = (new URLSearchParams(window.location.search).get('sorten') || '').split(',')
        .map(function (h) { return h.toLowerCase().replace(/[^a-z0-9-]/g, ''); }).filter(Boolean);
      var filled = 0;
      want.slice(0, selects.length).forEach(function (handle, i) {
        var sel = selects[i];
        for (var k = 0; k < sel.options.length; k++) {
          if (sel.options[k].getAttribute('data-handle') === handle && !sel.options[k].disabled) { sel.selectedIndex = k; filled++; break; }
        }
      });
      var note = root.querySelector('[data-sampler-prefill]');
      if (note && filled > 0) note.hidden = false;
    } catch (e) { /* ohne Vorbelegung weiter */ }
    var totalEl = root.querySelector('[data-sampler-total]');
    var listEl = root.querySelector('[data-sampler-breakdown]');
    var unitEl = root.querySelector('[data-sampler-unit]');
    var submitBtn = root.querySelector('[data-submit-btn]');
    var errorEl = root.querySelector('[data-form-error]');
    var qtyInput = root.querySelector('[data-quantity-input]');
    var label = submitBtn ? submitBtn.textContent.trim() : '';
    var vatAttr = root.getAttribute('data-b2b-vat');
    var vat = vatAttr === null ? -1 : parseFloat(String(vatAttr).replace(',', '.'));
    var b2b = !isNaN(vat) && vat >= 0;
    /* Brutto-Cent -> Netto-Cent (nur Firmenkunden-Ansicht) */
    function net(cents) { return b2b ? Math.round(cents * 100 / (100 + vat)) : cents; }

    function grind() {
      var active = root.querySelector('.kult-pdp-variant__pill.is-active');
      return active ? active.getAttribute('data-option-value') : '';
    }
    function qty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return n > 0 ? n : 1;
    }
    /* Variante eines Kaffees für Slot-Größe und Zubereitung */
    function variantFor(sel) {
      var opt = sel.options[sel.selectedIndex];
      var coffee = opt && data.coffees[opt.getAttribute('data-handle')];
      if (!coffee) return null;
      var size = sel.getAttribute('data-size') || '';
      var g = grind();
      for (var i = 0; i < coffee.v.length; i++) {
        var o = coffee.v[i].o || [];
        if (o.indexOf(size) > -1 && (!g || o.indexOf(g) > -1)) return { coffee: coffee, variant: coffee.v[i], size: size };
      }
      return null;
    }
    function picks() { return selects.map(variantFor); }
    /* „250 g“ / „1 kg“ / „0,5 kg“ -> Gramm */
    function grams(label) {
      var m = String(label || '').replace(',', '.').match(/([\d.]+)\s*(kg|g)\b/i);
      if (!m) return 0;
      var n = parseFloat(m[1]);
      return m[2].toLowerCase() === 'kg' ? Math.round(n * 1000) : Math.round(n);
    }
    function gramsLabel(g) {
      return g >= 1000 ? String(Math.round(g / 100) / 10).replace('.', ',') + ' kg' : g + ' g';
    }

    function render() {
      var list = picks();
      var total = 0;
      var ok = true;
      if (listEl) listEl.textContent = '';
      list.forEach(function (pick) {
        if (!pick) { ok = false; return; }
        if (!pick.variant.a) ok = false;
        var vPrice = net(pick.variant.p);
        total += vPrice;
        if (listEl) {
          var li = document.createElement('li');
          var name = document.createElement('span');
          name.textContent = pick.coffee.title + ', ' + pick.size;
          var price = document.createElement('span');
          price.className = 'kult-pdp-sampler__sum-price';
          price.textContent = pick.variant.a ? money(vPrice) : 'gerade nicht verfügbar';
          li.appendChild(name);
          li.appendChild(price);
          if (pick.variant.u && pick.variant.a) {
            var unit = document.createElement('span');
            unit.className = 'kult-pdp-sampler__sum-unit';
            unit.textContent = money(net(pick.variant.u)) + '/' + (pick.variant.r || 'kg');
            li.appendChild(unit);
          }
          listEl.appendChild(li);
        }
      });
      if (listEl) listEl.hidden = !list.length;
      if (totalEl) totalEl.textContent = money(total * qty());
      /* Mobile Kaufleiste (Cowork Mo-23 U8): kult-pdp.js hat sie an body gehängt, deshalb über document */
      var barSum = document.querySelector('[data-buybar-sum]');
      if (barSum) barSum.textContent = money(total * qty());
      var barBtn = document.querySelector('[data-buybar-sum-btn]');
      if (barBtn) {
        barBtn.disabled = !ok;
        if (!barBtn.hasAttribute('data-wired') && submitBtn) {
          barBtn.setAttribute('data-wired', '');
          barBtn.addEventListener('click', function () { if (!submitBtn.disabled) submitBtn.click(); });
        }
      }
      if (unitEl) {
        var g = selects.reduce(function (acc, sel) { return acc + grams(sel.getAttribute('data-size')); }, 0);
        var base = 'Summe der ' + (unitEl.getAttribute('data-count') || selects.length) + ' Kaffees';
        unitEl.textContent = g > 0 && ok
          ? base + ' · ' + gramsLabel(g) + ' (' + money(Math.round(total * 1000 / g)) + '/kg' + (b2b ? ' netto' : '') + ')'
          : base;
      }
      if (submitBtn && !submitBtn.hasAttribute('data-busy')) {
        submitBtn.disabled = !ok;
        submitBtn.textContent = ok ? label : 'Nicht verfügbar';
      }
      return ok;
    }

    function fail(msg) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = msg;
    }

    function submit(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!submitBtn || submitBtn.disabled) return;
      var list = picks();
      var n = qty();
      var byId = {};
      var items = [];
      for (var i = 0; i < list.length; i++) {
        if (!list[i] || !list[i].variant.a) { fail('Ein Kaffee ist in dieser Zubereitung gerade nicht verfügbar.'); return; }
        var id = list[i].variant.id;
        if (byId[id]) { byId[id].quantity += n; continue; }
        byId[id] = { id: id, quantity: n, properties: b2b ? { Set: data.label || 'Probierset', _kultb2b_quelle: 'shop' } : { Set: data.label || 'Probierset' } }; // Firmenkunden-Ansicht: Merker für assets/kult-cart.js und kult-b2b-reset.js (Attribut bleibt)
        items.push(byId[id]);
      }
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      submitBtn.setAttribute('data-busy', '');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird hinzugefügt…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error((body && body.description) || 'Das Probierset konnte nicht hinzugefügt werden.');
            return body;
          });
        })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          submitBtn.textContent = 'Im Warenkorb';
          document.dispatchEvent(new CustomEvent('kult:cart:add', { detail: { cart: cart, title: data.label || 'Probierset' } }));
          window.setTimeout(function () { submitBtn.removeAttribute('data-busy'); render(); }, 1200);
        })
        .catch(function (err) {
          submitBtn.removeAttribute('data-busy');
          render();
          fail(err.message || 'Es ist ein Fehler aufgetreten.');
        });
    }

    root.addEventListener('submit', submit, true);
    root.addEventListener('change', function (e) { if (e.target.closest('[data-sampler-select]')) render(); });
    /* Zubereitung und Menge setzt kult-pdp.js per Klick; danach neu rechnen */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-option-value], [data-step]')) window.setTimeout(render, 0);
    });
    /* kult-pdp.js belegt die Dropdowns aus ?s1=&s2=&s3= vor; danach einmal rechnen */
    window.setTimeout(render, 0);
    window.addEventListener('load', render);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sampler-sum]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
